var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#fluentColorChatMultiple160)",
    d: "M9 4a5 5 0 0 1 4.533 7.113l.457 2.289a.5.5 0 0 1-.588.588l-2.288-.457A5 5 0 1 1 9 4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fluentColorChatMultiple161)",
    d: "M7 2a5 5 0 0 0-4.533 7.113l-.457 2.289a.5.5 0 0 0 .588.588l2.288-.457A5 5 0 1 0 7 2"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "fluentColorChatMultiple160",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(4.60184 5.3384 -5.34296 4.60577 6.684 6.67)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#3d35b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#6553c9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7660d3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fluentColorChatMultiple161",
    x1: 2,
    x2: 12,
    y1: 2,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0fafff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2764e7"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.840037418b900c700df160ca0a3bd034.svg";
export { ForwardRef as ReactComponent };